import React, { useEffect } from "react";
import { useState } from "react";
import { Box, Grid, Link, Paper, Typography } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import CardDashboardResumo from "../../components/CardDashboardResumo";
import CardDashboardConsumo from "../../components/CardDashboardConsumo";
import CardDashboardUltimasConsultas from "../../components/CardDashboardUltimasConsultas";
import { Link as RouterLink } from "react-router-dom";
import iconAnalisesCredito from "../../images/icon-analises-credito.svg";

import relatorioService from "../../services/relatorioService";

const DashboardResumido = (props) => {
    const [dadosDashboard, setDadosDashboard] = useState({
        valor_mes: 0.0,
        valor_semana: 0.0,
        valor_hoje: 0.0,
        positivo: 0,
        negativo: 0,
        em_processamento: 0,
        total_consultas_mes: 0,
        total_analises: 0,
        saldo_credito: 0.0,
    });
    let dataHoje = new Date();
    /*const data_ini = new Date(dataHoje.getFullYear(), dataHoje.getMonth(),1)
    const data_fim = new Date(dataHoje.getFullYear(), dataHoje.getMonth() +1,0)*/

    const [relatorios, setRelatorios] = useState([]);
    const [data_ini, setCampoDataInicio] = useState(new Date());
    const [data_fim, setCampoDataFim] = useState(new Date());

    const alterarData = async (setData, value) => {
        setData(value);
        setDadosDashboard(
            await relatorioService.getDadosDashbordResumido(
                data_ini.getTime(),
                data_fim.getTime()
            )
        );
        setRelatorios(await relatorioService.getRelatoriosDashboard());
    };

    useEffect(async () => {
        setDadosDashboard(
            await relatorioService.getDadosDashbordResumido(
                data_ini.getTime(),
                data_fim.getTime()
            )
        );
        setRelatorios(await relatorioService.getRelatoriosDashboard());
    }, []);

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box marginTop="1rem" width="65rem" maxWidth="95vw">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={4}
                >
                    {/* <Grid item xs={12}>
            <CardDashboardBemVindo />
          </Grid> */}
                    <Grid item xs={12}>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Grid item xs={2}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    inputVariant="outlined"
                                    size="small"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="none"
                                    id="date-picker-inicio"
                                    label="Data Inicio"
                                    value={data_ini}
                                    autoOk
                                    name="datainicio"
                                    onChange={(e) =>
                                        alterarData(setCampoDataInicio, e)
                                    }
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Box
                                    textAlign="center"
                                    lineHeight="2.5rem"
                                    color="#0000008A"
                                    bgcolor="#0000001F"
                                    fontSize={14}
                                >
                                    Até
                                </Box>
                            </Grid>
                            <Grid item xs={5}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    inputVariant="outlined"
                                    size="small"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="none"
                                    id="date-picker-fim"
                                    label="Data Fim"
                                    value={data_fim}
                                    autoOk
                                    name="datafim"
                                    onChange={(e) =>
                                        alterarData(setCampoDataFim, e)
                                    }
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item md={7}>
                                <CardDashboardResumo dados={dadosDashboard} />
                            </Grid>
                            <Grid item md={5}>
                                <CardDashboardConsumo dados={dadosDashboard} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default DashboardResumido;
